<template>
	<div class="step-4">
		<h1 v-if="careerLevelEligible">{{ title }}</h1>
		<div class="tag-sections">
			<section v-if="careerLevelEligible" class="tag">
				<LockInfo class="mb-3"/>
				<CharacteristicSelectInline
					v-model="careerLevels"
					:characteristic-items="meta.careerLevel"
					:initial-amount="9"
					label-type="job-profile"
					@input="emitChangeEvent"
				/>
			</section>
			<section v-if="organisationalAreaEligible" class="tag">
				<h2>In welchem Organisationsbereich ist die Tätigkeit?</h2>
				<LockInfo class="mb-3"/>
				<CharacteristicEdit
					v-model="organisationalArea"
					title="In welchem Organisationsbereich ist die Tätigkeit?"
					with-keyword
					show-multiple-hint
					:characteristic-type="meta.organisationalAreaType"
					:characteristic-items="organisationalAreaItems"
					label-type="job-profile"
					open-fan-button-alignment="left"
					@input="emitChangeEvent"
				/>
			</section>
		</div>
	</div>
</template>

<script>
import CharacteristicEdit from "@/vue/characteristic/Edit";
import CharacteristicSelectInline from "@/vue/characteristic/SelectInline";
import {isDefined} from "@/helper/Value";
import {arrayIsNotEmpty} from "@/helper/Array";
import {mapState} from "vuex";
import {clearSelected, filterItems} from "@/helper/characteristic/OrganisationalArea";
import LockInfo from "@/vue/common/LockInfo.vue";

export default {

	components: {
		LockInfo,
		CharacteristicEdit,
		CharacteristicSelectInline,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		title: {
			type: String,
			required: true,
		},
		careerLevelEligible: {
			type: Boolean,
			required: true,
		},
		organisationalAreaEligible: {
			type: Boolean,
			required: true,
		},
		functions: {
			type: Array,
			required: true
		}
	},

	mounted ()
	{
		if (isDefined(this.careerLevels) && !this.careerLevelEligible)
		{
			this.organisationalArea = undefined;
		}

		if (isDefined(this.organisationalArea))
		{
			if (!this.organisationalAreaEligible)
			{
				this.organisationalArea = undefined;
			}
			else
			{
				this.organisationalArea = clearSelected(this.organisationalArea, this.meta, this.functions);
			}
		}

		this.emitChangeEvent();
	},

	data ()
	{
		return {
			careerLevels: this.value?.careerLevels,
			organisationalArea: this.value?.organisationalArea,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		organisationalAreaItems ()
		{
			return filterItems(this.meta, this.functions);
		},
		careerLevelsValid ()
		{
			return !this.careerLevelEligible || (isDefined(this.careerLevels) && arrayIsNotEmpty(this.careerLevels));
		},
		organisationalAreaValid ()
		{
			return !this.organisationalAreaEligible
				|| (isDefined(this.organisationalArea) && arrayIsNotEmpty(this.organisationalArea));
		},
		valid ()
		{
			return this.careerLevelsValid
				&& this.organisationalAreaValid;
		},
	},

	methods: {
		emitChangeEvent ()
		{
			this.$emit('input', {
				careerLevels: this.careerLevelEligible ? this.careerLevels : undefined,
				organisationalArea: this.organisationalAreaEligible ? this.organisationalArea : undefined,
				valid: this.valid,
			});
		}
	}
}
</script>
